export const SizeClasses = {
  SIZE_SM: ['wf-py-1', 'wf-px-2', 'wf-text-xs'],
  SIZE_MD: ['wf-py-2', 'wf-px-4', 'wf-text-sm'],
  SIZE_LG: ['wf-py-3', 'wf-px-6', 'wf-text-lg'],
  SIZE_XL: ['wf-py-4', 'wf-px-8', 'wf-text-xl'],
  SIZE_2XL: ['wf-py-8', 'wf-px-16', 'wf-text-3xl']
}